






































import JsonViewer from 'vue-json-viewer'
import {Component, Prop, Vue} from "vue-property-decorator";
import AmView from "@/valchrom/views/dataset/AmView.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        AmView,
        JsonViewer
    }
})
export default class AmGroups extends Vue {
    name = "AmGroups";
    @Prop() am_groups: any;
    @Prop() analyte: any;

    @Getter overview_simplify !: boolean;

    accordionAction(id:string) {
        var accordionButton = document.getElementById(id)
        var contentOfAccordion :any= document!.getElementById(id)!.nextSibling
        if (contentOfAccordion!.style!.display == "block") {
            contentOfAccordion!.style!.display = "none"
            accordionButton!.classList.remove("is-primary");
        } else if (contentOfAccordion.style.display == "none") {
            contentOfAccordion.style.display = "block"
            accordionButton!.classList.add("is-primary");
        } else if(contentOfAccordion.style.display == "") {
            contentOfAccordion.style.display = "block"
            accordionButton!.classList.add("is-primary");
        }

        // accordionButton class
        //TODO uncomment
        /*var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
        otherAccordions.forEach(function(otherAccordionButton){
            if(accordionButton != otherAccordionButton){
                var content : any= otherAccordionButton.nextSibling
                content!.style!.display = "none"
                otherAccordionButton.classList.remove("is-primary");
            }
        })*/
    }

    hasData(am_group: any){
        for(let code in am_group.ams){
            let am = am_group.ams[code];
            let AMViewLocal: any = AmView; // had some type error
            if(AMViewLocal.hasData(am)){
                return true;
            }
        }
        return false;
    }
}
